import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect } from "react";
import { FaBuilding, FaEnvelope, FaPhone, FaUser } from "react-icons/fa";
import { Button, Col, Container, FormFeedback, FormGroup, Input, Label, Row } from "reactstrap";
import * as Yup from "yup";
import { Homesectionimage } from "../Data/ComponentsData/componentsdata";
import AnimationCommon from "../common/AnimationCommon";
import Footer from "../components/footer";

const Request = () => {
  useEffect(() => {
    document.body.classList.remove("inner-page");
  }, []);

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    companyName: Yup.string().required("Company name is required"),
    email: Yup.string().email("Invalid email format").required("Email is required"),
    phoneNumber: Yup.string()
      .matches(/^[0-9]+$/, "Phone number must be digits only")
      .required("Phone number is required"),
  });

  const initialValues = {
    name: "",
    companyName: "",
    email: "",
    phoneNumber: "",
  };

  const handleSubmit = (values, { resetForm }) => {
    resetForm();
  };

  return (
    <div className='page-margin'>
      <section className='auth-page request-page'>
        <AnimationCommon />
        <Container>
          <Row>
            <Col md='6' className='request-left'>
              <div className='auth-card schedule-demo'>
                <div className='main'>
                  <div className='mb-4 text-start'>
                    <h2>Schedule demo</h2>
                  </div>
                  <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                    {({ isSubmitting, errors, touched }) => (
                      <Form className='auth-form'>
                        <FormGroup className='form-group'>
                          <Label>Name</Label>
                          <FaUser className='icon-setting' />
                          <Field name='name' as={Input} invalid={touched.name && !!errors.name} placeholder='Name' />
                          <ErrorMessage name='name' component={FormFeedback} />
                        </FormGroup>
                        <FormGroup className='form-group'>
                          <Label>Company name</Label>
                          <FaBuilding className='icon-setting' />
                          <Field name='companyName' as={Input} invalid={touched.companyName && !!errors.companyName} placeholder='Company name' />
                          <ErrorMessage name='companyName' component={FormFeedback} />
                        </FormGroup>
                        <FormGroup className='form-group'>
                          <Label>Email</Label>
                          <FaEnvelope className='icon-setting' />
                          <Field name='email' type='email' as={Input} invalid={touched.email && !!errors.email} placeholder='Email' />
                          <ErrorMessage name='email' component={FormFeedback} />
                        </FormGroup>
                        <FormGroup className='form-group'>
                          <Label>Phone number</Label>
                          <FaPhone className='icon-setting' />
                          <Field name='phoneNumber' type='tel' as={Input} invalid={touched.phoneNumber && !!errors.phoneNumber} placeholder='Phone Number' />
                          <ErrorMessage name='phoneNumber' component={FormFeedback} />
                        </FormGroup>
                        <FormGroup className='form-group mb-0 text-start'>
                          <Button className='submit ' color='primary' disabled={isSubmitting}>
                            Schedule Demo
                          </Button>
                        </FormGroup>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </Col>
            <Col md='6' className='request-right d-grid align-items-center'>
              <div className='home-right position-relative'>
                {Homesectionimage.map((image, index) => (
                  <div key={index} className={image.class}>
                    <img src={image.src} alt={image.alt} className='img-fluid' />
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
    </div>
  );
};

export default Request;
